import { FormErrorMessage as FormErrorMessageComponent } from '@bambi/component-library/src/components/forms/FormErrorMessage/FormErrorMessage';

// TODO: update imports to use CL directly
export const FormErrorMessage = FormErrorMessageComponent;
